
import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';

import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';

import { KeySelectItem } from '@core/models/select-item.model';
import { CoreCustomFormsFiltersService } from '@core/services/custom-forms/custom-forms.service';
import * as CformsSearch from '@core/custom-forms/models/field-search.model';

import { Label } from '@core/objects/label';

@Component({
    selector: 'form-field-fill-single-tag-selector-v1',
    templateUrl: './fill-single-tag-selector-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FillSingleTagSelectorV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public placeholder: string = "Choose a tag";
    public items: Array<KeySelectItem> = [];  
    public availableLabels: Array<Label>;
    public selectedTag: Label;
    public valid: boolean = false;

    private subs: Subscription[] = [];

    constructor(private filtersSrv: CoreCustomFormsFiltersService,
        private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.subs.push(
            this.filtersSrv.selectInitializedLabelsFilter().subscribe((initialized: boolean) => {
                if(!initialized)
                    this.filtersSrv.loadLabelsFilter();
            })
        );
        this.subs.push(
            this.filtersSrv.selectLabels().subscribe((filter: CformsSearch.SearchAvailableFilters) => {
                if(filter && filter.items?.length > 0){
                    this.availableLabels = filter.items.filter((l:Label) => l.group.id == this.fieldSubmission.field.options.category) as Label[];
                    if(this.fieldSubmission.serialized_value){
                        this.selectedTag = this.availableLabels.find((l: Label) => l.id.toString() === this.fieldSubmission.serialized_value.id.toString() );
                        this.valid = this.selectedTag !== null;
                        this.emitValidity();
                    }
                    this.cdr.markForCheck();
                }
            })
        );
    }

    onTagSelect(tag: Label) {
        this.selectedTag = tag;
        this.valid = this.selectedTag && this.selectedTag !== null || !this.fieldSubmission.field.mandatory;
        // console.log(" Single tag onTagSelect => ",tag);
        if(this.valid)
            this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: tag.id});
        this.emitValidity();
    }

    remove(){
        this.selectedTag = null;
        this.valid = false || !this.fieldSubmission.field.mandatory;
        this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: null});
        this.emitValidity();

    }

    private emitValidity(): void {
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.fieldSubmission.field.mandatory ? this.valid :  true });
    }

}
